export default __webpack_public_path__ + "static/media/placeholder.ec428377.jpg";